// src/components/layout/Sidebar.jsx
import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";

const menuItems = [
  { section:"Principal", items:[
    { icon:"bi-speedometer2",      label:"Dashboard",               id:"dashboard"           },
    { icon:"bi-graph-up-arrow",    label:"Dashboard Financeiro",    id:"dashboard-financeiro" },
  ]},
  { section:"Cadastros", items:[
    { icon:"bi-buildings",         label:"Condomínios",        id:"condominios"       },
    { icon:"bi-people",            label:"Condôminos",         id:"condominos"        },
    { icon:"bi-house-door",        label:"Unidades",           id:"unidades"          },
    { icon:"bi-person-badge",      label:"Funcionários",       id:"funcionarios"      },
    { icon:"bi-truck",             label:"Fornecedores",       id:"fornecedores"      },
  ]},
  { section:"Financeiro", items:[
    { icon:"bi-journal-bookmark",  label:"Plano de Contas",    id:"contasContabeis"   },
    { icon:"bi-bank",              label:"Contas Bancárias",   id:"contasBancarias"   },
    { icon:"bi-receipt-cutoff",    label:"Contas a Pagar",     id:"contasPagar"       },
    { icon:"bi-cash-coin",         label:"Pagamentos",         id:"pagamentos"        },
    { icon:"bi-collection",         label:"Cobranças",          id:"cobrancas"         },
    { icon:"bi-ticket-perforated", label:"Controle Boletos",   id:"boletos"           },
    { icon:"bi-handshake",          label:"Renegociação",       id:"renegociacoes"     },
    { icon:"bi-arrow-down-circle", label:"Contas a Receber",   id:"contasReceber"     },
    { icon:"bi-file-earmark-arrow-down", label:"Retorno CNAB",  id:"retorno-cnab"      },
    { icon:"bi-arrow-clockwise",   label:"Desp. Recorrentes",  id:"despesasRecorrentes"},
    { icon:"bi-calendar-check",    label:"Fechamento Mensal",  id:"fechamento-mensal" },
  ]},
  { section:"Rel. Financeiros", items:[
    { icon:"bi-bar-chart-line",        label:"DRE",                  id:"rel-dre"              },
    { icon:"bi-journal-text",          label:"Balancete",            id:"rel-balancete"         },
    { icon:"bi-list-columns-reverse",  label:"Extrato Analítico",   id:"rel-extrato-analitico" },
    { icon:"bi-file-earmark-bar-graph",label:"Prestação de Contas", id:"rel-prestacao"         },
    { icon:"bi-file-earmark-spreadsheet",label:"Demonstrat. Rec/Desp", id:"rel-demonstrativo"    },
  ]},
  { section:"Rel. de Gestão", items:[
    { icon:"bi-exclamation-triangle",  label:"Inadimplência",       id:"rel-inadimplencia"     },
    { icon:"bi-card-list",             label:"Extrato por Unidade", id:"rel-extrato"           },
    { icon:"bi-droplet-half",          label:"Água e Gás",          id:"rel-consumo"           },
  ]},
  { section:"Portaria", items:[
    { icon:"bi-shield-check",     label:"Dashboard Portaria", id:"portaria-dashboard" },
  ]},
  { section:"Operacional", items:[
    { icon:"bi-door-open",         label:"Áreas Comuns",       id:"areasComuns"       },
    { icon:"bi-calendar-check",    label:"Reservas",           id:"reservas"          },
    { icon:"bi-droplet",             label:"Água e Gás",         id:"consumo"           },
    { icon:"bi-list-check",          label:"Checklists",         id:"checklists"        },
  ]},
  { section:"Controle de Estoque", items:[
    { icon:"bi-box-seam",            label:"Estoque",            id:"estoque"           },
    { icon:"bi-cart-check",          label:"Pedidos",            id:"pedidos"           },
    { icon:"bi-receipt",             label:"Compras",            id:"compras"           },
    { icon:"bi-ui-checks-grid",      label:"Cotação",            id:"cotacao"           },
    { icon:"bi-clipboard-check",     label:"Inventário",         id:"inventario"        },
  ]},
  { section:"Comunicação", items:[
    { icon:"bi-exclamation-circle",label:"Ocorrências",        id:"ocorrencias"       },
    { icon:"bi-megaphone",         label:"Comunicados",        id:"comunicados"       },
    { icon:"bi-people-fill",       label:"Assembleias",        id:"assembleias"       },
  ]},
  { section:"Admin SaaS", saasOnly:true, items:[
    { icon:"bi-speedometer2", label:"Dashboard", id:"saas-dashboard"},
    { icon:"bi-people-fill",  label:"Clientes",  id:"saas-clientes" },
    { icon:"bi-box-seam",     label:"Planos",    id:"saas-planos"   },
  ]},
  { section:"Sistema", items:[
    { icon:"bi-gear-wide-connected", label:"Cadastro de Jobs", id:"cadastro-jobs", perfis:["Admin"] },
    { icon:"bi-shield-lock",         label:"ControlID",        id:"controlid",     perfis:["Admin"] },
    { icon:"bi-shield-check",        label:"Logs de Auditoria",id:"audit",         perfis:["Admin"] },
    { icon:"bi-whatsapp",            label:"WhatsApp",         id:"whatsapp",      perfis:["Admin"] },
    { icon:"bi-people-fill",         label:"Usuários",         id:"usuarios",      perfis:["Admin"] },
    { icon:"bi-gear",                label:"Configurações",    id:"config",        perfis:["Admin"] },
  ]},
];

export default function Sidebar({ collapsed, mobileOpen, onNavigate, activeId, usuario: usuarioProp=null, badges={} }) {
  const { temAcesso, temModulo, isSuperAdmin, usuario: usuarioCtx } = useAuth();
  const usuario = usuarioCtx || usuarioProp; // prefer context over prop
  const [expanded, setExpanded] = useState({"relatorios": true});
  return (
    <aside className={`sidebar ${collapsed?"collapsed":""} ${mobileOpen?"mobile-open":""}`}>
      <div className="sidebar-logo">
        {!collapsed
          ? <img src="/logo.svg" alt="eCondo" style={{height:36,objectFit:"contain"}}/>
          : <div className="sidebar-logo-icon"><i className="bi bi-buildings-fill"/></div>
        }
      </div>
      <nav className="sidebar-nav">
        {menuItems.filter(section=>{
          if (section.saasOnly) return isSuperAdmin;
          return !section.perfis||section.perfis.includes(usuario?.perfil);
        }).map(section=>{
          return (
          <div key={section.section}>
            <div className="nav-section-label">{section.section}</div>
            {section.items
              .filter(item => {
                if (!(!item.perfis || item.perfis.includes(usuario?.perfil))) return false;
                if (!temAcesso(item.id)) return false;
                return true;
              })
              .map(item=>{
                // Verifica se o módulo está no plano (null = sem restrição)
                const bloqueadoPorPlano = !isSuperAdmin && !section.saasOnly
                  && !temModulo(item.id);
                const hasChildren = item.children && item.children.length > 0;
                const isExpanded = expanded[item.id];
                const isChildActive = hasChildren && item.children.some(ch=>ch.id===activeId);
                return (
                  <div key={item.id}>
                    <div
                      className={`nav-item ${(!hasChildren && activeId===item.id)||isChildActive?"active":""} ${bloqueadoPorPlano?"nav-item-locked":""}`}
                      title={bloqueadoPorPlano?"Módulo não disponível no seu plano. Faça upgrade!":""}
                      onClick={()=>{
                        if (bloqueadoPorPlano) return; // bloqueia navegação
                        if(hasChildren){ setExpanded(p=>({...p,[item.id]:!p[item.id]})); }
                        else { onNavigate&&onNavigate(item.id); }
                      }}>
                      <i className={`bi ${bloqueadoPorPlano?"bi-lock-fill ":item.icon}`}/>
                      {!collapsed&&<span className="nav-item-label" style={{flex:1,opacity:bloqueadoPorPlano?0.5:1}}>{item.label}</span>}
                      {!collapsed&&bloqueadoPorPlano&&(
                        <span style={{fontSize:9,background:"#F59E0B",color:"#fff",borderRadius:4,padding:"1px 5px",fontWeight:700,marginLeft:4}}>
                          PRO
                        </span>
                      )}
                      {/* Badge de contagem (ex.: reservas pendentes) */}
                      {!bloqueadoPorPlano && badges[item.id] > 0 && (
                        <span title={`${badges[item.id]} pendente(s)`}
                          style={{
                            background:"#EF4444", color:"#fff",
                            borderRadius:10, padding: collapsed?"1px 4px":"1px 7px",
                            fontSize: collapsed?9:10, fontWeight:700,
                            marginLeft: collapsed?0:6,
                            minWidth: collapsed?14:18, textAlign:"center",
                            position: collapsed?"absolute":"static",
                            top: collapsed?6:undefined, right: collapsed?4:undefined,
                          }}>
                          {badges[item.id] > 99 ? "99+" : badges[item.id]}
                        </span>
                      )}
                      {!collapsed&&hasChildren&&(
                        <i className={`bi bi-chevron-${isExpanded?"up":"down"}`}
                          style={{fontSize:10,opacity:.6,marginLeft:4}}/>
                      )}
                    </div>
                    {/* Sub-items */}
                    {hasChildren && isExpanded && !collapsed && (
                      <div style={{paddingLeft:12}}>
                        {item.children.filter(child=>temAcesso(child.id)).map(child=>(
                          <div key={child.id}
                            className={`nav-item ${activeId===child.id?"active":""}`}
                            style={{fontSize:12.5,paddingLeft:16}}
                            onClick={()=>onNavigate&&onNavigate(child.id)}>
                            <i className={`bi ${child.icon}`} style={{fontSize:13}}/>
                            <span className="nav-item-label">{child.label}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {/* Collapsed: show children as dots or tooltip */}
                    {hasChildren && collapsed && (
                      item.children.filter(child=>temAcesso(child.id)).map(child=>(
                        <div key={child.id}
                          className={`nav-item ${activeId===child.id?"active":""}`}
                          style={{paddingLeft:8,justifyContent:"center"}}
                          title={child.label}
                          onClick={()=>onNavigate&&onNavigate(child.id)}>
                          <i className={`bi ${child.icon}`} style={{fontSize:12}}/>
                        </div>
                      ))
                    )}
                  </div>
                );
              })}
          </div>
          );
        }
        )}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-user-avatar" style={{background:usuario?.perfil==="Admin"?"#1B3A6B":usuario?.perfil==="Gerente"?"#7C3AED":usuario?.perfil==="Sindico"?"#166534":"#C2410C"}}>
          {usuario?.nome ? usuario.nome.split(" ").slice(0,2).map(n=>n[0]).join("").toUpperCase() : "AS"}
        </div>
        {!collapsed&&(
          <div className="sidebar-user-info">
            <div className="sidebar-user-name">{usuario?.nome||"Admin Sistema"}</div>
            <div className="sidebar-user-role">{{Admin:"Administrador",Gerente:"Gerente",Sindico:"Síndico",Condomino:"Condômino"}[usuario?.perfil]||"Administrador"}</div>
          </div>
        )}
      </div>
    </aside>
  );
}
